// Initialize user timezone from browser or user profile
export const initializeTimezone = (userProfile = null) => {
  let timezone = localStorage.getItem('userTimezone');
  
  if (!timezone) {
    // Try to get from user profile (if available from server)
    if (userProfile?.timezone) {
      timezone = userProfile.timezone;
    } else {
      // Fall back to browser timezone
      timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    }
    localStorage.setItem('userTimezone', timezone);
  }
  
  console.log(`[TIMEZONE] Initialized: ${timezone}`);
  return timezone;
};

// Get current user timezone
export const getUserTimezone = () => {
  return localStorage.getItem('userTimezone') || Intl.DateTimeFormat().resolvedOptions().timeZone;
};

// Set user timezone (call when user changes region/timezone)
export const setUserTimezone = (timezone) => {
  localStorage.setItem('userTimezone', timezone);
  console.log(`[TIMEZONE] Updated to: ${timezone}`);
};

// Timezone mapping for common regions
export const TIMEZONE_MAP = {
  'IN': 'Asia/Kolkata',
  'US': 'America/New_York',
  'GB': 'Europe/London',
  'EU': 'Europe/Paris',
  'JP': 'Asia/Tokyo',
  'AU': 'Australia/Sydney',
  'SG': 'Asia/Singapore'
};
